import {
  fetch
} from '@/commons/fetch'
import {
  addScript
} from '@/commons/utils'


function isWechat() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}



const wechatShareConfig = (options) => {


  if (!isWechat()) {
    return;
  }
  var jssdk = '//res.wx.qq.com/open/js/jweixin-1.2.0.js'
  fetch({
    url: '//news-d.jin10.com/sign',
    params: {
      url: location.href
    },
    type: 'jsonp',
    jsonpCallback: 'jsonpCallback',
    success: (response) => {


      // alert(33);
      // 
      const data = response.data
      //alert(data.signature);
      //alert(data.timestamp);
      //alert(data.nonceStr);

      addScript(jssdk, () => {
        wx.config({
          debug: false,
          appId: 'wx4cbb30b2fd83dd88',
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        })




        var url= document.location.href;//"xnews.jin10.com/details.html?id=17686";

        //alert(options.imgUrl);
        wx.ready(function() {

          //alert(options.imgUrl);
          wx.onMenuShareTimeline({
            title: options.title, // 分享标题
            link: url,//document.location.href, // 分享链接
            imgUrl: options.imgUrl, // 分享图标
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            }
          })
          wx.onMenuShareAppMessage({
            title: options.title, // 分享标题
            desc: options.desc, // 分享描述
            link: url,// document.location.href, // 分享链接
            imgUrl: options.imgUrl, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            }
          })

          wx.error(function(res) {
            //alert("errorMSG:" + res);

          });
          //alert(options.title);
          //         alert(options.imgUrl);
        })
      })
    }
  })
}

export default wechatShareConfig


// WEBPACK FOOTER //
// ./src/commons/wechatShareConfig.js